export const imageWithLowSizeQuery = (url: string) => url + '?size=s';

export const withMediaUrl = (src: string, isLowSize = false) => {
  return `${import.meta.env.VITE_MEDIA_SERVER_DEFAULT_API_URL_PATH}${
    isLowSize ? imageWithLowSizeQuery(src) : src
  }`;
};
